import { SplitPayment } from './split-payment';

export class OrderPaymentOptions {
  paymentByWireTransferOnly = false;
  splitPayment = false;
  splitPayments: Array<SplitPayment> = [];
}
